import { Service } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Service()
export class OriginIdService {
  // A client instance, never a user because one user on two tabs must not have their own edits suppressed
  // on the other one, and a shared station login is two people behind one account.
  readonly originId = uuidv4();
}
